let TableSearch = {
	methods: {
	}
}

export default TableSearch
